import { useState, useEffect } from 'react'
import { useSignup } from '../../hooks/useSignup'
import { useNavigate } from 'react-router-dom'
import { Helmet } from 'react-helmet'

// styles
import styles from './Signup.module.css'
import useCreateId from '../../hooks/useCreateId'

export default function Signup() {
  const [ email, setEmail ] = useState('')
  const [ password, setPassword ] = useState('') 
  const [ displayName, setDisplayName ] = useState('')
  //const [ thumbnail, setThumbnail ] = useState(null)
  //const [ thumbnailError, setThumbnailError ] = useState(null)
  const { signup, error, isPending } = useSignup()
  const {docId : userId} = useCreateId('user')
  const navigate = useNavigate()

  const title = 'Founder'

  const handleSubmit = async(e) => {
    e.preventDefault()

    const tenantId = 'demo'
    const accessLevel = [
      {department: 'finance', level: 'read' },
      {department: 'operation', level: 'read' },
      {department: 'sales', level: 'read' },
      {department: 'marketing', level: 'read' },
      {department: 'company', level: 'read' },
      {department: 'administrator', level: 'none' },
    ]
    try {
      const res = await signup(email, password, displayName, /*thumbnail,*/ userId, tenantId, accessLevel, title)
      navigate('/loggingin')
      //console.log(error, isPending)
      //if (!error && !isPending) navigate('/loggingin')
      

    } catch (err) {
      console.log(err)
    }
  }


  return (
    <div>
      <Helmet>
        {/*-- Primary Meta Tags --*/}
        <title>Sign Up for Crifty | Start Your Free Bookkeeping Trial</title>
        <meta name="description" content="Join thousands of businesses simplifying their finances. Sign up for your free Crifty account and experience stress-free bookkeeping in minutes. No credit card required." />
        <meta name="keywords" content="sign up for crifty, create crifty account, free bookkeeping software, start free trial, bookkeeping app signup, expense tracking software" />
        <link rel="canonical" href="https://crifty.com/signup" />

        {/* Open Graph / Social Media Meta Tags */}
        <meta property="og:title" content="Sign Up for Crifty | Start Your Free Bookkeeping Trial" />
        <meta property="og:description" content="Join thousands of businesses. Sign up for Crifty and experience stress-free bookkeeping in minutes. No credit card required." />
        <meta property="og:image:alt" content="Sign up for Crifty Bookkeeping and simplify your finances" />
        <meta property="og:url" content="https://crifty.com/signup" />
        <meta property="og:site_name" content="Crifty" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://crifty.com/OG-crifty.webp" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        

        {/*-- Twitter Meta Tags --*/}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Sign Up for Crifty | Start Your Free Bookkeeping Trial" />
        <meta name="twitter:description" content="Sign up for Crifty and experience stress-free bookkeeping in minutes." />
        <meta name="twitter:image" content="https://crifty.com/OG-crifty.webp" />
        <meta name="twitter:site" content="@CriftyApp" />

        {/* Structured Data for Sign Up Page */}
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "WebPage",
              "name": "Sign Up for Crifty",
              "description": "Sign up for your free Crifty account and start simplifying your bookkeeping.",
              "url": "https://crifty.com/signup",
              "breadcrumb": {
                "@type": "BreadcrumbList",
                "itemListElement": [
                  {
                    "@type": "ListItem",
                    "position": 1,
                    "name": "Home",
                    "item": "https://crifty.com"
                  },
                  {
                    "@type": "ListItem",
                    "position": 2,
                    "name": "Sign Up"
                  }
                ]
              },
              "publisher": {
                "@type": "Organization",
                "name": "Crifty",
                "logo": {
                  "@type": "ImageObject",
                  "url": "https://crifty.com/logo.png"
                }
              }
            }
          `}
        </script>
      </Helmet>
      <form onSubmit={handleSubmit} className='split'>
        <h2>Sign Me Up!</h2>
        {/*<label>
          <span>User ID : </span>
          <span className='user-input'>{userId}</span>
        </label>*/}
        <label className="margin-p">
          <span>Email : </span>
          <input
            required
            type="email"
            onChange={(e) => setEmail(e.target.value)}
            value={email}
            autoComplete="email"
          />
        </label>
        <label className="margin-p">
          <span>Password : </span>
          <input
            required
            type="password"
            onChange={(e) => setPassword(e.target.value)}
            value={password}
            autoComplete="current-password"
          />
        </label>
        <label className="margin-p">
          <span>Name : </span>
          <input
            required
            type="text"
            onChange={(e) => setDisplayName(e.target.value)}
            value={displayName}
          />
        </label>
        {/*<label>
          <span>Profile Picture : </span>
          <input
            required
            type="file"
            onChange={handleFileChange}                    
          />
          {thumbnailError && <div className="error">{thumbnailError}</div>}
        </label>*/}
        
        <div className="message-container">
          {!isPending && <button className="btn">Sign Up</button>}
          {isPending && <button className="btn" disabled>Loading</button>}
          {error && <div className="error">{error}</div>}
        </div>
      </form>
    </div>
  )
}